<template>
  <div class="expandable-drawer-container" @click="onClick">
    <div>
      <slot name="collapsed"></slot>
    </div>
    <div :style="getExpandedSlotStyle">
      <slot name="expanded"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "expandable-drawer",
  data() {
    return {
      isExpanded: this.expanded,
      expandedSlotHeight: 0
    };
  },
  props: {
    changeOpacity: {
      type: Boolean,
      default: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.expandedSlotHeight = this.$el.children[1].firstChild.clientHeight;
  },
  updated() {
    this.expandedSlotHeight = this.$el.children[1].firstChild.clientHeight;
  },
  watch: {
    expanded(value) {
      this.isExpanded = value;
      this.emitEvent();
    }
  },
  methods: {
    emitEvent() {
      const event = this.isExpanded ? "expanded" : "collapsed";
      this.$emit(event);
    },
    onClick() {
      if (!this.disabled) {
        this.isExpanded = !this.isExpanded;
        this.emitEvent();
      }
    }
  },
  computed: {
    getExpandedSlotStyle() {
      return {
        transition: "all 0.3s ease-in-out",
        contain: "content",
        height: `${this.isExpanded ? this.expandedSlotHeight : 0}px`,
        opacity: `${this.isExpanded || !this.changeOpacity ? 1 : 0}`,
        pointerEvents: `${this.isExpanded ? "auto" : "none"}`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.expandable-drawer-container {
  &:hover {
    cursor: pointer;
  }
}
</style>
